import React from 'react';
import DateTimeField, { DateTimeFieldProps } from './DateTimeField';
import { getJobTimezone } from 'utils/time';
import { useRecordContext } from 'react-admin';

export interface JobDateTimeFieldProps extends Omit<DateTimeFieldProps, 'tzSource' | 'timeZone'> {
  tzSource?: string;
  timeZone?: string;
}

/**
 * A DateTimeField component that automatically determines the correct timezone for job records
 * based on whether it's an assignment or SaaS job
 */
const JobDateTimeField = (props: JobDateTimeFieldProps) => {
  const { tzSource, timeZone, ...otherProps } = props;
  const record = useRecordContext();

  // If tzSource is provided, use it directly (for backward compatibility)
  if (tzSource) {
    return <DateTimeField tzSource={tzSource} {...otherProps} />;
  }

  // If timeZone is provided, use it directly
  if (timeZone) {
    return <DateTimeField timeZone={timeZone} {...otherProps} />;
  }

  // Otherwise, determine the timezone from the record
  const jobTimezone = getJobTimezone(record);
  return <DateTimeField timeZone={jobTimezone} {...otherProps} />;
};

export default JobDateTimeField;
